import type { HeadInfo } from '~/modules/head/entities/HeadInfo'
import { ALIAS_PATH } from '~/modules/views/cottage/constants'
import decoratorCottageToHeadInfo from '~/modules/views/cottage/utils/decoratorCottageToHeadInfo'
import { useHeadInfoComposable } from '~/modules/head/composables/useHeadInfoComposable'
import decoratorCottageToMenuBreadcrumb from '~/modules/views/cottage/utils/decoratorCottageToMenuBreadcrumb'
import { useMenuBreadcrumbStore } from '~/modules/menu/stores/useMenuBreadcrumbStore'
import { useHeadSchemaComposable } from '~/modules/head/composables/useHeadSchemaComposable'

import type { CottagePage } from '~/modules/views/cottage/entities/CottagePage'

export const usePageConfiguration = (cottagePage: CottagePage) => {
  const route = useRoute()
  const { setHeadInfo } = useHeadInfoComposable()

  const isAliasPath = route.matched.some(
    matchedRoute => matchedRoute.path === ALIAS_PATH,
  )

  const cottageHeadInfo: HeadInfo = decoratorCottageToHeadInfo(cottagePage, {
    // TODO: delete when the page in nuxt-pages dies
    robotsVisible: !isAliasPath,
  })
  setHeadInfo(cottageHeadInfo)

  const cottageMenuBreadcrumb = decoratorCottageToMenuBreadcrumb(cottagePage)
  const breadCrumbMenuStore = useMenuBreadcrumbStore()
  breadCrumbMenuStore.setMenuBreadcrumb(cottagePage.name, cottageMenuBreadcrumb)

  const { lodgingBusinessSchema, productSchema } = useHeadSchemaComposable()
  lodgingBusinessSchema({
    name: cottagePage.name,
    image: cottagePage.media.length > 0 ? cottagePage.media[0].url : '',

    priceRange: toEuro(cottagePage.averagePriceAmount.amount),

    address: {
      name: `${cottagePage.address}, ${cottagePage.postalCode} - ${cottagePage.village.name}, ${cottagePage.province.name}`,
    },
  })
  if (
    cottagePage.reviews?.reviews &&
    cottagePage.reviews?.reviews.length > 0 &&
    cottagePage.reviews?.summaryDTO
  ) {
    productSchema({
      name: cottagePage.name,
      description: cottagePage.description,
      image: cottagePage.media.length > 0 ? cottagePage.media[0].url : '',
      sku: cottagePage.slug,
      aggregateRating: {
        ratingValue: cottagePage.reviews?.summaryDTO.averageReviewScore,
        bestRating: cottagePage.reviews?.summaryDTO.bestScore,
        ratingCount: cottagePage.reviews?.summaryDTO.countScore,
      },
    })
  }
}
